import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, observable, runInAction } from "mobx";
class TcfVendor {
    /**
     * Get existing vendor configuration for this vendor.
     */ get vendorConfiguration() {
        for (const c of this.store.vendorConfigurations.entries.values()){
            var _c_vendorModel;
            if (((_c_vendorModel = c.vendorModel) == null ? void 0 : _c_vendorModel.data.id) === this.data.id) {
                return c;
            }
        }
        return undefined;
    }
    /**
     * Calculate a map of restrictions for this vendor. This can be used to make a form
     * configurable depending on the current vendor.
     */ get restrictivePurposes() {
        const result = {
            normal: {}
        };
        for (const purpose of [
            ...this.legIntPurposes,
            ...this.purposes
        ]){
            result.normal[purpose.data.id.toString()] = {
                enabled: true,
                legInt: this.legIntPurposes.indexOf(purpose) > -1 && !purpose.special ? "yes" : "no"
            };
        }
        return result;
    }
    /**
     * Map the integers to valid declaration objects.
     */ get purposes() {
        var _this_data;
        return (_this_data = this.data) == null ? void 0 : _this_data.purposes.map((id)=>this.store.purposes.get(`${id}`));
    }
    get legIntPurposes() {
        var _this_data;
        return (_this_data = this.data) == null ? void 0 : _this_data.legIntPurposes.map((id)=>this.store.purposes.get(`${id}`));
    }
    get specialPurposes() {
        var _this_data;
        return (_this_data = this.data) == null ? void 0 : _this_data.specialPurposes.map((id)=>this.store.specialPurposes.get(`${id}`));
    }
    get features() {
        var _this_data;
        return (_this_data = this.data) == null ? void 0 : _this_data.features.map((id)=>this.store.features.get(`${id}`));
    }
    get specialFeatures() {
        var _this_data;
        return (_this_data = this.data) == null ? void 0 : _this_data.specialFeatures.map((id)=>this.store.specialFeatures.get(`${id}`));
    }
    get dataCategories() {
        var _this_data;
        return (_this_data = this.data) == null ? void 0 : _this_data.dataDeclaration.map((id)=>this.store.dataCategories.get(`${id}`));
    }
    constructor(data, store){
        runInAction(()=>{
            this.data = data;
        });
        this.store = store;
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], TcfVendor.prototype, "data", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], TcfVendor.prototype, "vendorConfiguration", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], TcfVendor.prototype, "restrictivePurposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], TcfVendor.prototype, "purposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], TcfVendor.prototype, "legIntPurposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], TcfVendor.prototype, "specialPurposes", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], TcfVendor.prototype, "features", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], TcfVendor.prototype, "specialFeatures", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], TcfVendor.prototype, "dataCategories", null);
export { TcfVendor };
